import React from "react";
import StriderWriting from "@assets/images/strider-writing.svg";
import ErrorContent from "@components/ErrorContent/ErrorContent";
import config from "@/config";

export const WpErrorSection: React.FC = () => {
  return (
    <ErrorContent
      title="Something went wrong!"
      message={
        <>
          <p>This content is currently unavailable. Please try reloading the page.</p>
          <p className="mt-0">
            Need more help? Try{" "}
            <a
              href={config.HELP_CENTER_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              contacting support
            </a>
            .
          </p>
        </>
      }
      image={StriderWriting}
    />
  );
};
